import { module } from "modujs";
import productFormMixin from "../vue-mixins/product-form-mixin";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // Retrieve shopify product values
        this.productVariants = JSON.parse(document.getElementById('productFormVariants').innerHTML);
        this.productCurrentVariantId = JSON.parse(this.getData('current-variant-id'))
        this.productOptions = JSON.parse(document.getElementById('productFormOptions').innerHTML);
        this.productQuantities = JSON.parse(this.getData('quantities'))
        this.productColors = JSON.parse(this.getData('colors'))
        
        // Init vue
        this.initVue();
    }

    initVue() { 
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el,

            delimiters: ["${", "}"],

            mixins: [ productFormMixin ],

            data: {
                isReady:    false,
                rating:     0
            },

            beforeCreate() {
                this.moduleInstance = moduleInstance
            },

            mounted() {
                this.$nextTick(() => {
                    this.isReady = true
                })
            },

            methods: {
                onAddToCart(itemId, quantity = 1) {
                    this.moduleInstance.call('addItem', { id: itemId, quantity }, 'CartModal')
                },

                onProductVariantChange(variantId) {
                    this.moduleInstance.call('onProductVariantChange', variantId, 'ProductGallery')
                },

                openDelivery() {
                    this.moduleInstance.call('open', null, 'Popup', 'delivery')
                },
                
                openWarranty() {
                    this.moduleInstance.call('open', null, 'Popup', 'warranty')
                }
            }
        });
    }

    cannotAddMoreItem() {
        // Display too much items error
        if (this.app) {
            this.app.isQuantityExceed = true
        }
    }

    setProductRating(rating) {
        if (this.app) {
            this.app.rating = rating
        }
    }

    destroy() {
        super.destroy();
        
        if (this.app) {
            this.app.$destroy();
        }
    }
}
